interface IRemoveInteractionsOption {
  container: JQuery
}

export class DigitalSignatureCurrentStatus {

  public container: JQuery

  constructor(options: IRemoveInteractionsOption) {
    this.container = options.container
  }

  public set(html: string): void {
    this.container.html(`<p class='statusMessage--success'> ${ html }</p>`)
  }

  public setError(html: string): void {
    this.container.html(`<p class='statusMessage--error'> ${ html }</p>`)
  }

  public clear(): void {
    this.set('')
  }
}
